import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useRoute} from '@/common/services/router';
import {AnyRouteResult} from '@/app/interfaces/routing';
import {RouteName} from '@/app/constants/routing';
import {selectForecastLocationStableId} from '@/app/store/forecast/selectors';
import {selectMapCountryStableId} from '@/app/store/maps/selectors';

/**
 * The hook produces targeting data based on the current viewing weather location
 */
export function useDfpTargeting() {
	const {route} = useRoute<AnyRouteResult>();
	const forecastLocationStableId = useSelector(selectForecastLocationStableId);
	const mapCountryStableId = useSelector(selectMapCountryStableId);

	useEffect(() => {
		if (route.name === RouteName.weather || (route.name === RouteName.mainPage && forecastLocationStableId)) {
			googletag.cmd.push(() => {
				googletag.pubads().clearTargeting();
				googletag.pubads().setTargeting('city', forecastLocationStableId.id || '');
				googletag.pubads().setTargeting('country', forecastLocationStableId.countryId || '');
			});
		} else if (route.name === RouteName.map) {
			googletag.cmd.push(() => {
				googletag.pubads().clearTargeting();
				googletag.pubads().setTargeting('country', mapCountryStableId || '');
			});
		}
	}, [route]);
}

useDfpTargeting.displayName = 'useDfpTargeting';
